module.exports = __webpack_public_path__ + "static/media/bike-avaiable.77a6369e.svg";